import { render, staticRenderFns } from "./DashboardDetailPatrol4m.vue?vue&type=template&id=2e3bb80a&scoped=true&"
import script from "./DashboardDetailPatrol4m.vue?vue&type=script&lang=js&"
export * from "./DashboardDetailPatrol4m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3bb80a",
  null
  
)

export default component.exports